import React, { createContext, useState, useEffect } from "react";

export const ClientesContext = createContext();

export function ClientesProvider({ children }) {
    const [clientes, setClientes] = useState([]);

    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL; // pega a URL do backend do .env

        const fetchClientes = async () => {
            try {
                const token = localStorage.getItem('token');
                const estabelecimentoId = localStorage.getItem('estabelecimento_id');

                const headers = {
                    'Content-Type': 'application/json'
                };

                // Adicionar token ao header se existir
                if (token) {
                    headers['Authorization'] = `Bearer ${token}`;
                }

                // Admin pode ter mais de um estabelecimento — manda qual está
                // selecionado no painel pro backend não assumir o primeiro dele.
                const url = estabelecimentoId
                    ? `${API_URL}/buscaclientes?estabelecimento_id=${estabelecimentoId}`
                    : `${API_URL}/buscaclientes`;

                const response = await fetch(url, { headers });

                if (!response.ok) {
                    throw new Error(`Erro HTTP: ${response.status}`);
                }

                const data = await response.json();
                setClientes(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Erro ao buscar clientes:", error);
                setClientes([]); // Define como array vazio em caso de erro
            }
        };

        fetchClientes();

        // 📢 Listener para recarregar clientes após login
        const handleLoginSuccess = () => {
            console.log('📢 [ClientesContext] Evento loginSuccess recebido, recarregando clientes...');
            fetchClientes();
        };

        window.addEventListener('loginSuccess', handleLoginSuccess);

        // Limpar listener ao desmontar
        return () => {
            window.removeEventListener('loginSuccess', handleLoginSuccess);
        };
    }, []);

    return (
        <ClientesContext.Provider value={{ clientes }}>
            {children}
        </ClientesContext.Provider>
    );
}
